import { render, staticRenderFns } from "./SubscriptionBoxOrderFraudReviewList.vue?vue&type=template&id=527044d6&scoped=true&lang=pug&"
import script from "./SubscriptionBoxOrderFraudReviewList.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionBoxOrderFraudReviewList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SubscriptionBoxOrderFraudReviewList.vue?vue&type=style&index=0&id=527044d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527044d6",
  null
  
)

export default component.exports